import { useAtomValue } from "jotai";
import { canv } from "@/canv/global";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { HStack } from "@/shared/ui/Stack";
import type { DocumentPreviewPageOption, widgetOption } from "@/widgetMenu/widgetMenu";
import { checkIsDocumentViewer } from "../../lib";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { MenuButton } from "../MenuButton/MenuButton";
import { SubMenu } from "../SubMenu/SubMenu";
import styles from "./DocumentPreviewPageMenu.module.css";

interface DocumentPreviewPageMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function DocumentPreviewPageMenu({
    activeSubMenu,
    setActiveSubMenu,
}: DocumentPreviewPageMenuProps) {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("documentPreviewPage")) as
        | widgetOption<DocumentPreviewPageOption>[]
        | undefined;

    const firstOption = options?.[0];

    if (!firstOption) {
        return null;
    }

    const { currentPageNumber, previewPageNumber } = firstOption.value;

    const handleSetPreviewPageButtonClick = () => {
        const selectedEntities = canv.canvasController.selected;

        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;

            if (child && checkIsDocumentViewer(child)) {
                child.setPreviewPage(currentPageNumber);
            }
        }

        setActiveSubMenu(null);
    };

    const handleGoToPreviewPageButtonClick = () => {
        const selectedEntities = canv.canvasController.selected;

        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;

            if (child && checkIsDocumentViewer(child)) {
                child.goToPage(previewPageNumber);
            }
        }

        setActiveSubMenu(null);
    };

    return (
        <SubMenu activeSubMenu={activeSubMenu}>
            <MenuButton onClick={handleSetPreviewPageButtonClick}>
                <HStack className={styles.text} as="span" gap={24}>
                    Закрепить эту страницу{" "}
                    <span className={styles.numberWrapper}>{currentPageNumber}</span>
                </HStack>
            </MenuButton>
            <MenuButton onClick={handleGoToPreviewPageButtonClick}>
                <HStack className={styles.text} as="span" gap={24}>
                    Перейти к закрепленной{" "}
                    <span className={styles.numberWrapper}>{previewPageNumber}</span>
                </HStack>
            </MenuButton>
        </SubMenu>
    );
}
